<template>
	<div class="full" style="background-color: white;">
		<el-form ref="payinfoform" :model="form" label-width="80px" style="flex: 1;position: relative;"
			element-loading-background="rgba(255, 255, 255, 0.5)">
			<el-form-item label="结算类型" label-width="80px" style="width: 600px;">
				<emun :formCreateInject="true" name="suppliersettlementtype" v-model="form.suppliersettlementtype" />
			</el-form-item>
			<el-form-item label="业务" label-width="80px" style="width: 600px;">
				<emun :formCreateInject="true" name="accountbusiness" v-model="form.accountbusiness" />
			</el-form-item>
			<el-form-item label="最小金额" label-width="80px" style="width: 600px;">
				<el-input-number size="mini" v-model="form.min" label="基础积分"></el-input-number>
			</el-form-item>
			<el-form-item label="最大金额" label-width="80px" style="width: 600px;">
				<el-input-number size="mini" v-model="form.max" label="附加积分"></el-input-number>
			</el-form-item>
		</el-form>
	</div>

</template>
<style scoped>
	.bread {
		flex-direction: column;
		align-items: center;
		justify-content: center;
	}
</style>
<script>
	import emun from '@_system/components/formcomponents/common/select/emun/select.vue'
	export default {
		props: {
			emunid: {
				default: () => {
					return 0
				}
			},
		},
		data() {
			return {
				form: {
					min: 0,
					max: 0,
					suppliersettlementtype: null,
					accountbusiness: null,
				}
			}
		},
		watch: {

		},
		created() {

		},
		mounted() {

		},
		computed: {

		},

		methods: {

			// onSubmit() {
			// 	if (!this.emunid) {
			// 		this.$message.error('请选类型')
			// 		return
			// 	}
			// 	this.$api.emunextend_paymentaccount.save({
			// 		emunvalueid: this.emunid,
			// 		min: this.form.min,
			// 		max: this.form.max,
			// 		suppliersettlementtype: this.form.suppliersettlementtype,
			// 		accountbusiness: this.form.accountbusiness,
			// 		introduce: this.form.introduce
			// 	}).then(() => {
			// 		this.$message.success('操作成功')
			// 	})
			// }
		},
		components: {
			emun
		}
	}
</script>